(function () {
  // Shoplift A/B: the new selector markup is rendered for everyone so both variants get identical
  // HTML from the server, and only variant B is activated. snippets/shoplift-api-live.liquid adds
  // the class and fires the event once Shoplift has resolved the bucket.
  const AB_CLASS = 'tlc-selector-b';
  const AB_EVENT = 'tlc:selector-ab';
  const isVariantB = () => document.documentElement.classList.contains(AB_CLASS);

  class VariantInstantPrice {
    constructor() {
      document.addEventListener("change", this.handleChange.bind(this));
    }

    handleChange(event) {
      if (!isVariantB()) return;

      const input = event.target;
      if (!(input instanceof HTMLElement) || !input.matches('input[type="radio"], select')) return;

      const picker = input.closest('variant-picker[data-template-product-match="true"]');
      if (!picker) return;

      const variantsScript = picker.querySelector("[data-variant-instant-prices]");
      const priceEl = picker
        .closest(".shopify-section")
        ?.querySelector('product-form-component [ref="addToCartButton"] .add-to-cart-text__price');
      if (!variantsScript || !priceEl) return;

      const variants = this.#parseVariants(variantsScript);
      if (!variants) return;

      const selected = this.#getSelectedOptions(picker);
      if (!selected) return;

      const match = variants.find((variant) =>
        Object.entries(selected).every(([position, value]) => variant[`option${position}`] === value)
      );
      if (typeof match?.price !== "number") return;

      priceEl.textContent = priceEl.textContent.replace(/[\d.,]+/, (match.price / 100).toFixed(2));
    }

    #parseVariants(variantsScript) {
      try {
        return JSON.parse(variantsScript.textContent || "[]");
      } catch {
        return null;
      }
    }

    #getSelectedOptions(picker) {
      const selected = {};

      for (const el of picker.querySelectorAll("[data-option-name][data-option-position]")) {
        const checked = el.querySelector('input[type="radio"]:checked, select');
        const value = checked instanceof HTMLInputElement || checked instanceof HTMLSelectElement ? checked.value : null;
        const position = el.getAttribute("data-option-position");
        if (!value || !position) return null;
        selected[position] = value;
      }

      return selected;
    }
  }

  // The loader lists this file in more than one branch; only ever instantiate once.
  if (!window.__tlcVariantInstantPrice) window.__tlcVariantInstantPrice = new VariantInstantPrice();
})();
